import React, { useState, useEffect, Fragment } from 'react';
import { Card, Button, Modal, ModalBody, Row, ModalFooter, ModalHeader, Label, Input, DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { API_Vouchers_Codes } from '../../../../../../constants/APIs';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import moment from 'moment'
import ConfirmModal from './forms/ConfirmModal';
import { CSVLink } from "react-csv";
import GenerateCodes from './forms/GenerateCodes';
import Validation from '../../../../../../components/Validation';
const headers = [
  { label: "Voucher Name", key: "voucherName" },
  { label: "Code", key: "code" },
  { label: "Purpose", key: "purpose" },
  { label: "Status", key: "status" },
  { label: "Craeted Date", key: "createdDate" }
];
const CodeList = ({ item, handleCodeList, propertyId, isBuyOption, amadeus, xolaIntegration, voucherId, currency, voucherName }) => {
  const [isshowDelete, setIshowDelete] = useState(false);
  const handleDeleteForm = () => {
    setIshowDelete(false);
  };
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [voidModal, setVoidModal] = useState(false);
  const [refundModal, setRefundModal] = useState(false);
  const [redeemModal, setRedeemModal] = useState(false);
  const [reason, setReason] = useState('');
  const [codelist, setCodeList] = useState([]);
  const [codeId, setCodeId] = useState('');
  const [status, setStatus] = useState('All');
  const [csvData, setCSVData] = useState([{
          'voucherName': '',
          'code': '',
          'purpose': '',
          'status': '',
          'createdDate':''
  }]);
  const [codeVisible, setCodeVisible] = useState(false);
  const csvReport = {
    data: csvData,
    headers: headers,
    filename: voucherName + ' Codes.csv'
  };
  useEffect(() => {
    handleLoadData('All');
  }, voucherId);
  const handleLoadData = (status) => {    
    AxiosAPI({
      url: `${API_Vouchers_Codes}?id=${voucherId}&status=${status}`,
      method: 'get'
    }).then((res) => {
    
      setCodeList(res.data);
      let codes = [];
      if (res.data.length > 0) {
        res.data.map((m) => codes.push({
          'voucherName': voucherName,
          'code': m.codeId,
          'purpose': m.purpose,
          'status': m.voucherCodeStatus,
          'createdDate': moment(m.createdDate).format('LL')
        }));
        setCSVData(codes);
      }
    })
  }  
  const handleCode = (type) => {    
    AxiosAPI({
      method: 'put',
      url: `${API_Vouchers_Codes}`,
      data: { 'codeId': codeId, 'voucherCodeStatus': type, 'Reason': reason }
    })
      .then(res => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
      }
      else {
        setReason('');
        setVoidModal(false);
        setRedeemModal(false);
        setRefundModal(false);
        handleLoadData(status);
      }
      })
      .catch(err => null);

  };


  return (
    <Colxx xxs="12" className="mt-3">
      
      <Row className="mb-4">
        <div className='col-md-6 mb-1'>
          <Button
            color="primary"
            outline
            size="lg"
            onClick={() => {
              setCodeVisible(!codeVisible);
            }}
            style={{ width: '100%', borderRadius: '6px' }}
          >
            + Generate Codes
          </Button>
        </div>
        <div className='col-md-6 mb-1'>
          {codelist !== undefined && codelist.length > 0 ?
            <CSVLink {...csvReport}>
              <Button
                color="primary"
                outline
                size="lg"
                style={{ width: '100%', borderRadius: '6px' }}
              >
                + Download
              </Button>
            </CSVLink> :
            <Button
              color="primary"
              outline
              size="lg"
              style={{ width: '100%', borderRadius: '6px' }}
            >
              + Download
            </Button>
          }
        </div>
      </Row>
      <Row className="mb-2">
        <Colxx xxs="10" md="2" className="">
          <a onClick={() => handleCodeList("voucherList")}>
            <h1 class="iconsminds-back"></h1></a>
        </Colxx>
      </Row>
      <Row className="col-md-12 mb-2">
        <Colxx xxs="2" md="2" className="mb-2">
          <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
            <DropdownToggle caret color="outline-dark" size="xs" >
              {status}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                key="2"
                value="All"
                onClick={(e) => {
                  setStatus("All");
                  handleLoadData("All");
                }}
              >        All
              </DropdownItem>
              <DropdownItem
                key="Available"
                value="Available"
                onClick={(e) => {
                  setStatus("Available");
                  handleLoadData("Available");
                }}
              >        Available
              </DropdownItem>
              <DropdownItem
                key="Sold"
                value="Sold"
                onClick={(e) => {
                  setStatus("Sold");
                  handleLoadData("Sold");
                }}
              >        Sold
              </DropdownItem>
              <DropdownItem
                key="Redeemed"
                value="Redeemed"
                onClick={(e) => {
                  setStatus("Redeemed");
                  handleLoadData("Redeemed");
                }}
              >        Redeemed
              </DropdownItem>
              <DropdownItem
                key="Void"
                value="Void"
                onClick={(e) => {
                  setStatus("Void");
                  handleLoadData("Void");
                }}
              >        Void
              </DropdownItem>
              <DropdownItem
                key="Refunded"
                value="Refunded"
                onClick={(e) => {
                  setStatus("Refunded");
                  handleLoadData("Refunded");
                }}
              >        Refunded
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Colxx>
      </Row>
      
      {codelist !== undefined && codelist.length > 0 && codelist.map((m) => (
        <Fragment>
          <Card className="d-flex flex-row mb-3">
            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
              <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <p className="mb-1  text-small w-15 w-sm-100">
                  <b>{voucherName}</b>
                </p>
                <p className="mb-1 ml-4 text-muted text-small w-15 w-sm-100">
                  {m.codeId}
                </p>
                <p className="mb-1 text-muted text-small w-15 w-sm-70">
                  {m.purpose}
                </p>
                <p className="mb-1 text-muted text-small w-15 w-sm-70">
                  <span style={{ color: `${m.voucherCodeStatus === 'Available' ? 'green' : 'red'}` }}>{m.voucherCodeStatus}</span>
                </p>
                <p className="mb-1 text-muted text-small w-15 w-sm-70">
                  {moment(m.createdDate).format('LL')}
                </p>
                <p className="mb-1 text-muted text-small w-15 w-sm-70">
                   {(m.voucherCodeStatus !== 'Void' && m.voucherCodeStatus !== 'Refunded'  )&& <UncontrolledDropdown className="w-15 text-center w-sm-100" style={{ position: 'absolute', marginTop: '-1rem', right: '-1.5rem' }} >
                    <DropdownToggle caret color="outline-dark" size="xs">
                      more
                    </DropdownToggle>
                    <DropdownMenu>
                       {m.voucherCodeStatus === 'Sold' && <DropdownItem
                        key='View'
                        onClick={() => { setCodeId(m.id); setRedeemModal(true) }}
                      >
                        Redeem voucher
                      </DropdownItem>}
                      {m.voucherCodeStatus === 'Available' && <DropdownItem
                        key='View'
                        onClick={() => { setCodeId(m.id); setVoidModal(true) }}
                      >
                        Void voucher
                      </DropdownItem>}
                      {m.voucherCodeStatus === 'Sold' && <DropdownItem
                        key='View'
                        onClick={() => { setCodeId(m.id); setRefundModal(true) }}
                      >
                        Refund voucher
                      </DropdownItem>}
                    </DropdownMenu>
                  </UncontrolledDropdown>}
                </p>
              </div>
            </div>
          </Card>

        </Fragment>
      ))}
      {codeVisible && <GenerateCodes
          formLabel="Generate Codes"
          visible={codeVisible}
          toggle={() => {
            setCodeVisible(!codeVisible);
          }}
          update={false}  
          id={voucherId}      
          handleLoadData={()=>handleLoadData('All')}    
          voucherName={voucherName}          
          propertyId={propertyId}
        /> }
      {redeemModal && <ConfirmModal
        showModal={redeemModal}
        message={"Are you sure you want to redeem the voucher ?"}
        title={"Redeem Confirmation"}
        buttonName={"Redeem"}
        hideModal={() => {
          setRedeemModal(false);
        }}
        redeemStatus={0}
        handleRedeemVoucher={() => handleCode('Redeemed')}
      />}
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
      <Modal
        isOpen={voidModal}
        toggle={() => setVoidModal(false)}
        size="lg"
        style={{ maxWidth: '30%' }}
      >
        <ModalHeader toggle={() => setVoidModal(false)}><h3>Voucher</h3></ModalHeader>
        <ModalBody><div className="">
          <Label>Reason</Label>
          <Input type="text" value={reason} onChange={(e) => setReason(e.target.value)}>
          </Input>
        </div></ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { handleCode('Void'); }}>
            Send
          </Button>
          <Button onClick={() => setVoidModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={refundModal}
        toggle={() => setRefundModal(false)}
        size="lg"
        style={{ maxWidth: '30%' }}
      >
        <ModalHeader toggle={() => setRefundModal(false)}><h3>Refund Voucher</h3></ModalHeader>
        <ModalBody><div className="">
          <Label>Reason</Label>
          <Input type="text" value={reason} onChange={(e) => setReason(e.target.value)}>
          </Input>
        </div></ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { handleCode('Refunded'); }}>
            Send
          </Button>
          <Button onClick={() => setRefundModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Colxx >
    
  );
}

export default React.memo(CodeList);
